import { FilterOutlined } from "@ant-design/icons";
import { ICellRendererParams } from "ag-grid-community";
import { Col, MenuProps, Pagination, Row, Select, Typography } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { MODULES } from "../../../configs/modules";
import { READ } from "../../../configs/operations";
import { useFeatureToggleSearchByOptions } from "../../../hooks/search";
import { useSearchHistory } from "../../../utils/filterHelper";
import { checkScreenAccess } from "../../../utils/helper";
import Permissions from "../../../utils/permissions";
import { Popup } from "../../atoms/Popup";
import DashboardLayout from "../../molecules/DashboardLayout";
import { SectionHeaderV2 } from "../../organism/SectionHeaderV2";
import { setFilterUnits } from "../App/SearchFilters/ducks/actions";
import { Modal } from "../BookingForm/components";
import AddSingleUnit from "../Properties/AddProperty/AddSingleUnit";
import { searchByOptions as baseSearchByOptions } from "./constants/searchByOptions";
import { getUnitDetails, getUnits, setFilters } from "./ducks/actions";
import { UnitGridData } from "./grid/types";
import { UnitsGrid } from "./grid/UnitsGrid";
import { useUnitsSearch } from "./hooks";

const limit = 50;

const { Text, Title } = Typography;

export default (props) => {
  const dispatch: any = useDispatch();
  const navigate = useNavigate();

  const [data, setData] = useState([]);
  const unitsApi = useSelector((state: any) => state.units.unitsList);
  const unitsFilters = useSelector((state: any) => state.units.unitsFilters);
  const [updateValue, setUpdateValue] = useState({});
  const userScreenAccess: any = useSelector((state: any) => state?.userScreens?.userScreenAccess);

  const defaultFilterByValues = { unitStatus: "vacant", usagesType: "all" };

  const [currentPage, setCurrentPage] = useState(unitsFilters?.currentPage || 1);
  const { searchHistory } = useSearchHistory(setFilterUnits);
  const [filterBy, setfilterBy] = useState(unitsFilters?.filterBy || defaultFilterByValues);
  const [loading, setLoading] = useState(false);
  const [unitPaymentPlans, setUnitPaymentPlan] = useState([]);
  const [showPaymentPlan, setShowPaymentPlan] = useState(false);
  const [isLoading, setUnitLoading]: any = useState(false);
  const [exportData, setExportData] = useState(false);
  const [hasExportDataBeenSet, setHasExportDataBeenSet] = useState(false);
  const [visible, setVisible] = useState(false);

  const searchByDefault = unitsFilters?.searchBy || "propertyName";
  const [selectedSearchBy, setSelectedSearchBy] = useState<string>(searchByDefault);
  const [searchValue, setSearchValue] = useState<string>(unitsFilters?.search ?? "");

  const { selectOptions, handleSearch, handleChangeSearchBy } = useUnitsSearch({
    selectedSearchBy,
    setSelectedSearchBy,
    setSearchValue,
  });

  let modalPayload: any = {
    iKey: "8",
    width: "55%",
    title: "Payment Plans",
    extraText: "",
    //   "You can add a new payment plan, edit, or disable an existing payment plan. If you add or edit a payment plan, you\nneed to send an approval request.",
  };

  const actionCellRenderer = (props: ICellRendererParams<UnitGridData>) => {
    const unitData = props.data?.record;
    const navigate = useNavigate();

    const onChangeHanldler = async (e) => {
      // WIP  pending check to be solved later
      localStorage?.removeItem("torType");
      // for tor rules
      if (e === "view_unit") {
        navigate(`/property-detail/${unitData?.propertyId}/unit/${unitData?._id}`, {
          state: {
            parentname: unitData?.propertyName,
            showNav: true,
            usageType: unitData?.unit?.usagesType,
          },
        });
      } else if (e === "add_booking") {
        navigate(`/newbookingform`, {
          state: {
            selectedUnit: {
              unit: unitData?.unit,
              bookingPeriod: unitData?.bookingPeriod,
              businessUnitId: unitData?.businessUnitId,
              businessUnitName: unitData?.businessUnitName,
              unitId: unitData?.unitId,
            },
            selectedProperty: { property_name: unitData?.propertyName, propertyId: unitData?.propertyId },
          },
        });
      } else if (e === "reserved" || e === "occupied") {
        getInnerUnitDetails(unitData?.unitId, "occupied");
      } else if (e === "view_price") {
        setShowPaymentPlan(true);
        setUnitPaymentPlan(unitData?.paymentPlan);
      }
    };

    return (
      <Select
        onChange={onChangeHanldler}
        className="Sentence"
        placeholder="Select an action"
        style={{ width: 150, textAlign: "center" }}
        allowClear
      >
        <>
          <React.Fragment>
            <Select.Option value={"view_unit"}>
              <Text>View Unit</Text>
            </Select.Option>

            {unitData.unitStatus === "vacant" &&
              Permissions.isAllowed(MODULES.PROPERTIES, [READ]) &&
              checkScreenAccess("bookings", false, userScreenAccess) && (
                <Select.Option value={"add_booking"} disabled={unitData?.blockData?.block}>
                  <Text>Add Booking</Text>
                </Select.Option>
              )}

            {unitData.unitStatus === "reserved" &&
              Permissions.isAllowed(MODULES.PROPERTIES, [READ]) &&
              checkScreenAccess("bookings", false, userScreenAccess) && (
                <Select.Option value={"reserved"}>
                  <Text>View Booking</Text>
                </Select.Option>
              )}

            {unitData.unitStatus === "occupied" &&
              Permissions.isAllowed(MODULES.PROPERTIES, [READ]) &&
              checkScreenAccess("leases", false, userScreenAccess) && (
                <Select.Option value={"occupied"}>
                  <Text>View Lease</Text>
                </Select.Option>
              )}

            {unitData?.paymentPlan[0]?.unitPaymentPlanId && (
              <Select.Option value={"view_price"}>
                <Text>Show Pricing</Text>
              </Select.Option>
            )}
          </React.Fragment>
        </>
      </Select>
    );
  };

  const MenuItems: MenuProps["items"] = [
    {
      label: "Active Tenancy",
      key: 0,
    },
    {
      label: "Payment Schedule",
      key: 2,
    },
  ];

  const defaultFilterOptions = [
    {
      name: "unitStatus",
      label: "Status",
      initialValue: unitsFilters.filterBy?.unitStatus || defaultFilterByValues?.unitStatus,
      options: [
        {
          value: "all",
          label: "All",
        },
        {
          value: "vacant",
          label: "Vacant",
        },
        {
          value: "reserved",
          label: "Reserved",
        },
        {
          value: "occupied",
          label: "Occupied",
        },
        {
          value: "blocked",
          label: "Blocked",
        },
      ],
    },
    {
      name: "usagesType",
      label: "Usage Type",
      initialValue: unitsFilters.filterBy?.usagesType || defaultFilterByValues?.usagesType,
      options: [
        {
          value: "all",
          label: "All",
        },
        {
          value: "residential",
          label: "Residential",
        },
        {
          value: "commercial",
          label: "Commercial",
        },
      ],
    },
  ];

  const [propertyOptions, setPropertyOptions] = useState(defaultFilterOptions);

  const getInnerUnitDetails = async (id, type) => {
    setLoading(true);
    try {
      const unit = await getUnitDetails(id);
      if (unit?.leaseStatus && unit?.leaseStatus != "draft")
        //ADDED CHECKS TO FIX DRAFT/NONDRAFT FORM ISSUE: REF->8142
        navigate(`/viewbookingform/${unit.leaseId}`);
      else navigate(`/newbookingform/${unit.leaseId}`);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const handlePagination = (pg) => {
    setCurrentPage(pg);
  };

  const refreshUnitsList = () => {
    setPropertyOptions(defaultFilterOptions);
    let paymentPlan = true;
    const params = { ...unitsFilters?.filterBy };

    if (exportData) {
      params["exportData"] = exportData;
      params["totalCount"] = unitsApi?.totalCount;
    }

    const searchBy = unitsFilters.searchBy === "unitCode" ? "search" : unitsFilters.searchBy;

    dispatch(
      getUnits(
        false,
        limit,
        unitsFilters.currentPage,
        unitsFilters.search,
        searchBy,
        params,
        setExportData,
        paymentPlan,
        setUnitLoading,
        setHasExportDataBeenSet
      )
    );
  };

  useEffect(() => {
    if (Object.keys(unitsFilters).length === 0 || unitsFilters.constructor !== Object || hasExportDataBeenSet) return;

    refreshUnitsList();
  }, [unitsFilters, exportData, hasExportDataBeenSet]);

  useEffect(() => {
    let currPage = currentPage;
    if (
      unitsFilters?.search != searchValue ||
      unitsFilters?.searchBy != selectedSearchBy ||
      unitsFilters?.filterBy != filterBy
    )
      currPage = 1;
    dispatch(setFilters({ search: searchValue, searchBy: selectedSearchBy, filterBy, currentPage: currPage }));
    setHasExportDataBeenSet(false);
  }, [searchValue, filterBy, currentPage]);

  const { searchByOptions } = useFeatureToggleSearchByOptions(baseSearchByOptions);

  useEffect(() => {
    let key = Object.keys(searchHistory)[0] ?? selectedSearchBy;
    if (searchByOptions?.length > 0)
      searchByOptions.map((item) => {
        if (key == item.value) item["default"] = true;
        else item["default"] = false;
        return item;
      });
  }, [searchHistory]);

  function handlePropertyChange(property, label) {
    setfilterBy({ ...filterBy, [label]: property.value });
  }

  const exportAction = () => {
    setHasExportDataBeenSet(false);
    setExportData(true);
  };

  const handleAddUnitSuccess = () => {
    setVisible(false);
    refreshUnitsList();
  };

  const popup = {
    title: (
      <Title level={3} className="m-0">
        {"Add Single Unit"}
      </Title>
    ),
    content: <AddSingleUnit onSuccess={handleAddUnitSuccess} />,
    width: 850,
    style: { padding: "10px" },
  };

  const popupProps = {
    closable: true,
    visibility: visible,
    title: popup?.title,
    content: popup?.content,
    width: popup?.width,
    style: popup?.style,
    onCancel: () => setVisible(false),
    onSuccess: () => setVisible(false),
  };

  return (
    <>
      <DashboardLayout load={loading}>
        <Row gutter={[32, 32]}>
          <Col span={24}>
            <Row gutter={[24, 24]}>
              <Col span={24}>
                <SectionHeaderV2
                  heading="Units"
                  noBorder={true}
                  total={unitsApi?.totalCount || 0}
                  addNewAction={() => setVisible(true)}
                  dropItems={MenuItems}
                  dropTrigger={["click"]}
                  onSearch={handleSearch}
                  onChangeSearchBy={handleChangeSearchBy}
                  defaultSearch={searchValue}
                  searchByOptions={searchByOptions}
                  selectOptions={selectOptions}
                  downloadAction={exportAction}
                  viewOption={propertyOptions}
                  viewOptionIcon={<FilterOutlined />}
                  justifiedItems={true}
                  updateValue={updateValue}
                  justifyEnd={true}
                  handleView={handlePropertyChange}
                />
              </Col>
              <Col flex="auto">
                <Pagination
                  className="ag-property-text-pagination"
                  total={unitsApi?.totalCount || 0}
                  showTotal={(total, range) => `Showing ${range[0]}-${range[1]} of ${total} Units`}
                  showSizeChanger={false}
                  defaultPageSize={50}
                  defaultCurrent={1}
                  current={unitsFilters?.currentPage || currentPage}
                  onChange={(e) => handlePagination(e)}
                />
              </Col>
              <UnitsGrid
                unitStatusFilter={filterBy?.unitStatus}
                isLoading={isLoading}
                actionCellRenderer={actionCellRenderer}
              />
            </Row>
          </Col>
        </Row>

        <Modal
          className="bd-modal"
          unitPaymentPlan={unitPaymentPlans}
          modalPayload={modalPayload}
          showPaymentPlan={showPaymentPlan}
          setShowPaymentPlan={setShowPaymentPlan}
        />
      </DashboardLayout>
      <Popup destroyOnClose={true} {...popupProps} />
    </>
  );
};
